import { useEffect, useState } from "react"

interface NightModeConfig {
  enabled: boolean
  startHour: number
  endHour: number
  timezone?: string | null
}

interface NightModeState {
  active: boolean
}

function isNightTime(startHour: number, endHour: number, timezone?: string | null): boolean {
  let hour: number
  try {
    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: timezone || undefined,
      hour: "numeric",
      hour12: false,
    })
    hour = parseInt(formatter.format(new Date()), 10)
  } catch {
    hour = new Date().getHours()
  }

  // Handle wrapping (e.g., 22:00 to 07:00)
  if (startHour > endHour) {
    return hour >= startHour || hour < endHour
  }
  return hour >= startHour && hour < endHour
}

export function useTvNightMode({ enabled, startHour, endHour, timezone }: NightModeConfig): NightModeState {
  const [active, setActive] = useState(() => enabled && isNightTime(startHour, endHour, timezone))

  useEffect(() => {
    const check = () => setActive(enabled && isNightTime(startHour, endHour, timezone))
    check()
    const interval = setInterval(check, 60_000)
    return () => clearInterval(interval)
  }, [enabled, startHour, endHour, timezone])

  return { active }
}
